module.exports = __webpack_public_path__ + "static/media/Zarp Logo.d0f835ec.png";